import React from "react";
import {ENTITY_TYPE} from "utils/entities";
import EntityList from "./EntityList";

// Default export: Generic Component
export {default as EntityList} from "./EntityList";

// Named exports: List with 'entityType' predefined.
export const AssetsList = (props) => (
  <EntityList entityType={ENTITY_TYPE.assets} {...{...props}} />
);

export const ObservablesList = (props) => (
  <EntityList entityType={ENTITY_TYPE.observables} {...{...props}} />
);

export const IndicatorsList = (props) => (
  <EntityList entityType={ENTITY_TYPE.indicators} {...{...props}} />
);

export const RelationsList = (props) => (
  <EntityList entityType={ENTITY_TYPE.relations} {...{...props}} />
);
